/* ==================================================================
 *  people#show PC、SP共通
 * ================================================================== */
// NOTE: jQuery 3.x では $('selector').ready() がセレクタを無視して全ページで発火するため、
// $(function(){}) + 明示的なページガードに変更する
$(() => {
  if (!$("body.people.show").length) return;
});
/* ==================================================================
 *  people_mypage_people#edit PC、SP共通
 *  #HACK people_mypage/common/pages/people.es6を作る
 * ================================================================== */
$(() => {
  if (!$("body.people_mypage.people.edit").length) return;
  $("#introductionOfFirstEditProfile").modal();
});
